import { clsx } from "clsx";

type BodyPartPillProps = {
  label: string;
  selected: boolean;
  onClick: () => void;
  isLoading?: boolean;
};

export function BodyPartPill({ label, selected, onClick, isLoading = false }: Readonly<BodyPartPillProps>) {
  if (isLoading) {
    return <div className="h-[56px] w-24 animate-pulse rounded-2xl border border-gray-800/10 bg-gray-200" />;
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(
        "font-area rounded-2xl border-2 px-8 py-4 text-lg font-bold transition-all duration-75",
        selected
          ? "border-primary-100 bg-white text-gray-900"
          : "border-gray-800/15 bg-white text-gray-800 hover:border-gray-800/10 hover:bg-primary-50",
      )}>
      {label}
    </button>
  );
}
